import Layout from "../components/Layout/Layout";
import DealerStockDetailContent from "../components/DealerStockContent/DealerStockDetailContent";

const DealerStockDetail = () => {
    return (
        <Layout>
            <DealerStockDetailContent />
        </Layout>
    );
};

export default DealerStockDetail;
